import { TaskFilterField } from "../types/TaskFilterField.interface";

export const taskFilterFields: TaskFilterField[] = [
  {
    name: "description",
    label: "Omschrijving",
    type: "text",
    placeholder: "Zoek op omschrijving",
  },
  {
    name: "status",
    label: "Status",
    type: "select",
    placeholder: "Selecteer status",
    options: [
      { label: "Alle statussen", value: null },
      { label: "Open", value: "open" },
      { label: "Afgerond", value: "completed" },
    ],
  },
  {
    name: "priority",
    label: "Prioriteit",
    type: "select",
    placeholder: "Selecteer prioriteit",
    options: [
      { label: "Alle prioriteiten", value: null },
      { label: "Normaal", value: "normal" },
      { label: "Urgent", value: "urgent" },
    ],
  },
];
